var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('quillEditor',{staticClass:"roma-editor",attrs:{"options":_vm.editorOption,"content":_vm.info},on:{"change":function($event){return _vm.onEditorChange($event)}}})}
var staticRenderFns = []

export { render, staticRenderFns }